import SearchService from '../classes/SearchService';
import { BIKE_TYPES, MAX_RIDER_HEIGHT } from '../constants/bike';

const searchService = new SearchService();

// Calculate bike size, which child should buy after growing up

export default bike => {

    const maxBikeHeight = searchService.getHeightRange().max;
    const { wheel, type } = bike;

    const riderHeight = MAX_RIDER_HEIGHT.filter(bikeParams => bikeParams.wheel === wheel);
    if (!riderHeight || !riderHeight.length) return Number(maxBikeHeight) - 1;

    const { max } = riderHeight[0];
    if (!max) return;

    const { defaultHeight } = max;

    // Different max height depends on bike type
    const bikeType = BIKE_TYPES[type];
    return max[bikeType] ? max[bikeType] : defaultHeight;
}


// WEBPACK FOOTER //
// ./src/functions/getDueHeight.js